export enum UploadImageModule {
    UPLOAD_BANK_STATEMENT = 'upload-bank-statement',
    UPLOAD_USER_PHOTO = 'upload-user-photo',
    UPLOAD_USER_IC_FRONT = 'upload-user-ic-front',
    UPLOAD_USER_IC_BACK = 'upload-user-ic-back',
    UPLOAD_BANK_SLIP = 'upload-bank-slip'
}